// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ZlLDE","title":"Header_title__d0D3z","left":"Header_left__frqnF","clinicName":"Header_clinicName__P8ey6"};